import { render } from "./NexoraAssistant.vue?vue&type=template&id=35d33038"
import script from "./NexoraAssistant.vue?vue&type=script&lang=js"
export * from "./NexoraAssistant.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__